/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef, useState, Suspense } from "react";
import {
  useGLTF,
  useAnimations,
  TransformControls,
  ContactShadows,
  useCursor,
} from "@react-three/drei";
import _ from "lodash";
import async from "async";
import { Howl } from "howler";

import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { useFrame, useLoader, useThree } from "@react-three/fiber";

import {
  animateLetter,
  playIdle,
  fadeToAction,
  run
} from "../../utils/animationHelpers";

import useStore from "../../store";

import * as THREE from "three";

function Controls(current = null) {
  // Get notified on changes to state
  // const snap = useSnapshot(state);
  console.log(current.current);
  const scene = useThree((state) => state.scene);
  console.log(scene.getObjectByName(current.current));
  return (
    <>
      {current && (
        <TransformControls
          object={scene.getObjectByName(current.current)}
          mode="translate"
        />
      )}
    </>
  );
}

export function Woman(props) {
  const group = useRef();
  const mesh = useRef();

  const setCanPlay = useStore((state) => state.setCanPlay);

  const { scene, animations, nodes } = useLoader(
    GLTFLoader,
    "models/woman_fix_jaw.glb"
  );
  const { actions } = useAnimations(animations, scene);

  console.log();

  const [sound, setSound] = useState(null);
  const [current, setCurrent] = useState("");

  useEffect(() => {
    console.log(actions);
    playIdle(actions.IDLE_01, 0.7);
  }, []);

  useEffect(() => {
    setCanPlay(false);
    const sound = new Howl({
      src: [props.currentPolly.polly.audioUrl],
      volume: 1,
      rate: props.playBackSpeed,
      onload: function () {
        setCanPlay(true);
        console.log("sound", sound._duration);
      },
      onend: function () {},
    });
    setSound(sound);
  }, [props.currentPolly]);

  useEffect(() => {
    // TODO - weird check to avoid unnecessary plays
    if (
      props.play &&
      sound &&
      (!window.playNum || window.playNum < props.play)
    ) {

      // return run(props.currentPolly.polly.viseme);

      setCanPlay(false);
      playIdle(actions.IDLE_Talking, 0.7, () => {
        console.log("IDLE_Talking done");
        sound.play();
        window.timing = 0;
        let t0 = performance.now();
        async.eachSeries(
          props.currentPolly.polly.viseme,
          (letter, callback) => {
            animateLetter(actions, letter, props.playBackSpeed, callback);
          },
          (err, res) => {
            let t1 = performance.now();
            console.log(
              "Call to doSomething took " +
                parseFloat(t1 - t0) +
                " milliseconds."
            );
            playIdle(actions.IDLE_01, 0.7, () => {
              setCanPlay(true);
              console.log("--> A Done");
            });
          }
        );
      });

      // fadeToAction(actions.IDLE_Talking, 1, 5000, () => {

      // });
    }
    window.playNum = props.play;
  }, [props.play]);

  const select = (e) => {
    if (e.intersections.length > 0) {
      console.log(e.intersections[0].object.name);
      setCurrent(e.intersections[0].object.name);
    }
  };

  // const [mixer] = useState(() => new THREE.AnimationMixer());

  // useFrame((scene, delta) => {
  //   mixer.update(delta);

  //   // if (window.mouse) moveJoint(window.mouse, nodes.Neck);

  //   return;
  // });

  return (
    <>
      <Suspense fallback={null}>
        <primitive object={scene} ref={mesh} onClick={select} />
      </Suspense>
      {/* <Controls current={current} /> */}
    </>
  );
}

useGLTF.preload("/woman_07-transformed.glb");
